import React from 'react';
import { GCPCloudAccountAdd } from './GCPCloudAccountAdd';
import { GCPCloudAccountEdit } from './GCPCloudAccountEdit';

/**
 * GCP Cloud Account - Orchestrator Component
 * Routes to Add or Edit mode based on isEditMode prop
 */
export const GCPCloudAccount = ({ isEditMode, ...props }) => {
    return isEditMode ? <GCPCloudAccountEdit {...props} /> : <GCPCloudAccountAdd {...props} />;
};
